'use es6';

const BLOG_ACCESS = 'blog-access';
const LANDINGPAGES_ACCESS = 'landingpages-access';
const SERVICE_KNOWLEDGE_ACCESS = 'service-knowledge-access';
const SITEPAGES_ACCESS = 'sitepages-access';
const PAGES_ACCESS = 'pages-access';
const SITE_CONTENT = [BLOG_ACCESS, LANDINGPAGES_ACCESS, SERVICE_KNOWLEDGE_ACCESS, SITEPAGES_ACCESS, PAGES_ACCESS];
export function hasSiteContentAccess(hasScope) {
  return SITE_CONTENT.some(hasScope);
}